var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38866 12C1.28567 12.0005 1.18362 11.9804 1.08849 11.9409C0.99337 11.9014 0.907091 11.8433 0.834718 11.7701C0.687923 11.6231 0.605469 11.4238 0.605469 11.2161C0.605469 11.0084 0.687923 10.8091 0.834718 10.6622L5.50666 5.99022L0.834718 1.31827C0.696253 1.16968 0.620871 0.973134 0.624454 0.770055C0.628037 0.566976 0.710306 0.373215 0.853927 0.229594C0.997548 0.085973 1.19131 0.00370522 1.39439 0.000122126C1.59747 -0.00346097 1.79401 0.0719203 1.94261 0.210385L7.16849 5.43628C7.31529 5.58325 7.39774 5.78249 7.39774 5.99022C7.39774 6.19795 7.31529 6.39718 7.16849 6.54416L1.94261 11.7701C1.87023 11.8433 1.78395 11.9014 1.68883 11.9409C1.59371 11.9804 1.49165 12.0005 1.38866 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.9d0c9c0e6fd7258d17c56858891b338c.svg";
export { ForwardRef as ReactComponent };